import { PolicyTable } from '../../types/cancelAndModifyPolicies'

export function sortPolicies(data: PolicyTable[]) {
  const BeforeCheckInTime = data.filter(
    (policy) => policy.policyType === 'BeforeCheckInTime'
  )
  const AfterReservationTime = data.filter(
    (policy) => policy.policyType === 'AfterReservationTime'
  )
  const AfterCheckInTime = data.filter(
    (policy) => policy.policyType === 'AfterCheckInTime'
  )
  const BeforeCheckoutTime = data.filter(
    (policy) => policy.policyType === 'BeforeCheckOutTime'
  )
  const BeforeCheckInTimeSorted = BeforeCheckInTime.sort(
    (a, b) => a.deadline - b.deadline
  )
  const AfterReservationTimeSorted = AfterReservationTime.sort(
    (a, b) => a.deadline - b.deadline
  )
  const AfterCheckInTimeSorted = AfterCheckInTime.sort(
    (a, b) => a.deadline - b.deadline
  )
  const BeforeCheckoutTimeSorted = BeforeCheckoutTime.sort(
    (a, b) => a.deadline - b.deadline
  )
  return AfterReservationTimeSorted.concat(
    BeforeCheckInTimeSorted,
    AfterCheckInTimeSorted,
    BeforeCheckoutTimeSorted
  )
}
